import { useCallback } from 'react';

import { CONFIRM_POPUP_MODE, useConfirmPopup } from 'src/components/ConfirmPopup';
import { CustomTypography } from 'src/components/CustomTypography';
import {
  CHANNEL,
  getChannelPerformanceLabel,
  isExportChannel,
  isExternalChannel,
  isMetaChannel,
} from 'src/data/channel';

export const useConfirmUnauthorizeFromChannel = () => {
  const confirmPopup = useConfirmPopup();

  const alignChannelLabel = (channel) =>
    isMetaChannel(channel)
      ? `${getChannelPerformanceLabel(CHANNEL.facebook)}, ${getChannelPerformanceLabel(
          CHANNEL.facebookPages
        )} and ${getChannelPerformanceLabel(CHANNEL.instagram)}`
      : getChannelPerformanceLabel(channel);

  return useCallback(
    (channel) => {
      return confirmPopup({
        mode: CONFIRM_POPUP_MODE.warning,
        title: `Disconnect Integration?`,
        content: (
          <CustomTypography>
            {isExternalChannel(channel) || isExportChannel(channel) ? (
              `Are you sure you want to disconnect ${alignChannelLabel(channel)} integration?`
            ) : (
              <>
                You will no longer be able to access your <b>{alignChannelLabel(channel)}</b> data
                in this workspace.
                <br />
                Please note that disconnecting this data will also disconnect other members.
              </>
            )}
          </CustomTypography>
        ),
        buttons: {
          confirm: 'Disconnect',
        },
        withReject: true,
      })
        .then(() => true)
        .catch(() => false);
    },
    [confirmPopup]
  );
};
